import React, { ChangeEvent } from "react"
import { MenuItem, TextField, Box } from "@mui/material"

import LockingInformationDialog from "components/Dialogs/LockingInformationDialog"

import Price from "components/Price"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setSelectedCylinderLockingMechanism,
} from "@secureo/common/reducers/productDetailPageReducer"
import { netToGross } from "@secureo/common/utils/tax"
import { CylinderLockingMechanism } from "@secureo/common/typings/Product"

const LockingMechanismConfiguration = ({ isLoading, dispatch, reducerState, taxRate }: Props) => {
	const { cylinderLockingMechanismProducts, selectedCylinderLockingMechanism } = reducerState
	const onChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
		const mechanism = event.target.value as CylinderLockingMechanism

		setSelectedCylinderLockingMechanism(dispatch, reducerState, mechanism)
	}

	const singleLockingProduct = cylinderLockingMechanismProducts?.single ?? null
	const singleLockingNetPriceCents = singleLockingProduct?.netPriceCents ?? 0
	const singleLockingGrossPriceCents = Math.round(netToGross(singleLockingNetPriceCents, taxRate))

	const simultaneousLockingProduct = cylinderLockingMechanismProducts?.simultaneous ?? null
	const simultaneousLockingNetPriceCents = simultaneousLockingProduct?.netPriceCents ?? 0
	const simultaneousLockingGrossPriceCents = Math.round(
		netToGross(simultaneousLockingNetPriceCents, taxRate),
	)

	return (
		<div>
			<Box mb={-1} style={{ display: "flex", alignItems: "center" }}>
				<LockingInformationDialog />
			</Box>
			<TextField
				id="outerLength"
				label="Schließmechanismus"
				value={selectedCylinderLockingMechanism?.mechanism}
				onChange={onChange}
				margin="normal"
				variant="filled"
				select
				fullWidth
				disabled={isLoading}
			>
				{singleLockingProduct && (
					<MenuItem value="single">
						<span style={{ marginRight: 3 }}>Einzelschließend</span>
						<Price priceInEuroCents={singleLockingGrossPriceCents} />
					</MenuItem>
				)}

				{simultaneousLockingProduct && (
					<MenuItem value="simultaneous">
						<span style={{ marginRight: 3 }}>Gleichschließend</span>
						<Price priceInEuroCents={simultaneousLockingGrossPriceCents} />
					</MenuItem>
				)}
			</TextField>
		</div>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	taxRate: number
}

export default LockingMechanismConfiguration
